<template>
  <div>
    <Modal v-model="visible" width="85" :title="title" :footer-hide="true" :mask-closable="false" class="my-modal vertical-center-modal">
      <div class="batchMatching">
        <div class="searchValueBtn">
          <Input v-model.trim="searchParams.value" :autosize="{ minRows: 4, maxRows: 10 }" type="textarea" placeholder="请输入保单号，多个保单号换行输入，可粘贴" />
          <Button type="primary" @click="matchPolicy">匹配保单</Button>
        </div>
        <div class="batchBtn">
          <span class="toggleBtn" @click="visible1 = true">输入示例</span>
        </div>
        <div class="matchingResult" v-if="unmatchedList.length>0">
          <Alert type="warning">
            <i class="iconfont iconzhuyi1"></i>
            <span class="textResult">未匹配到的保单号:（系统无此保单、系统无费用数据、不属于个险保单、不属于对账类型、不属于此供应商的数据）</span>
              <template #desc>
                <div v-for="(item,index) in unmatchedList" :key="index">
                  {{ item }}
                </div>
              </template>
          </Alert>
        </div>

        <div v-if="showTable">
          <div class="search-box">
            <div class="input-item" v-if="searchParams.reconciliationType == 4 ||searchParams.reconciliationType == 5">
              <span class="label">保单年度</span>
              <Input v-model="searchParams.commissionIndex" placeholder="请输入正整数" type="number" @on-change="changeValue('commissionIndex')" />        
            </div>
            <div class="input-item">
              <span class="label" style="width:105px;">交费期次</span>
              <Input v-model="searchParams.commissionPeriods" placeholder="请输入正整数" type="number" @on-change="changeValue('commissionPeriods')" />
            </div>
            <div class="input-item" v-if="reconciliationType == 1">
            <span class="label">费用类型</span>
            <Select v-model="searchParams.commissionTypes" clearable multiple :max-tag-count="1">
              <Option value="1">基础费用</Option>
              <Option value="2">限时加费活动</Option>
            </Select>
          </div>
          <div class="input-item" v-if="reconciliationType == 4">
            <span class="label">费用类型</span>
            <Select v-model="searchParams.commissionTypes" clearable multiple :max-tag-count="1">
              <Option value="3">续期基础费用</Option>
              <Option value="4">续年度服务津贴</Option>
            </Select>
          </div>
            <div class="input-item" v-if="searchParams.reconciliationType == 1 ||searchParams.reconciliationType == 3">
                <span slot="label" class="label">
                  是否扣款记录<span class="tip-icon">?</span>
                  <div class="pop-tip">
                    <span>因退保等原因已扣除费用的记录</span>
                    <div class="arrow"></div>
                  </div>
                </span>

                <RadioGroup v-model="searchParams.queryDeduct"  @on-change="getList">
                  <Radio label="">全部</Radio>
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </div>
              <div class="btn-item">
              <Button type="primary" @click="getList">查询</Button>
            </div>
          </div>

          <div><span style="color: red;">如选择已在其他对账单的记录，将会自动将该条记录从原对账单剔除。</span></div>

          <!-- 工具栏 -->
          <div class="tools-box">
            <div class="left-box">
              <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
            </div>
            <div class="right-box">
              <span class="text"
                >已选择<span>{{ isAll ? total : ids.length }}</span
                >条，共<span>{{ total }}</span
                >条数据</span
              >
            </div>
          </div>

          <div class="tableBox">
            <loading :isShow="listLoading" />
            <Table :columns="columns" :data="tableData" @on-selection-change="selectionChange"> 
              <template slot-scope="{ row }" slot="reconciliationStatusDesc">
                <div>
                  {{ getReconciliationStatus(row.reconciliationStatus) }}
                </div>
              </template>
              <template slot-scope="{ row }" slot="userName_staffNo">
                <div class="name-status">
                  <div class="user-box">
                    <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
                    <span class="user-name">{{ row.owerStaffNo }}/{{ row.owerName }}</span>
                  </div>
                </div>
              </template>
            </Table>
          </div>
          <Page
            :total="total"
            :current.sync="pageNum"
            :page-size="pageSize"
            show-total
            @on-change="getList"
            style="text-align: center; margin-top: 20px; margin-bottom: 20px"
          />
        </div>
        

        <div class="ivu-modal-footer">
          <Button size="default" @click="visible = false">取消</Button>
          <Button type="primary" @click="addStatement" v-preventReClick>加入对账单</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="visible1" width="300" :title="title1" :footer-hide="true" :mask-closable="false" class="my-modal top">
      <div class="tipsTitle">
        每一行一个保单号
      </div>
      <Input v-model="value" :disabled="true" :rows="4" type="textarea" placeholder="请输入保单号，多个保单号换行输入，可粘贴" />
    </Modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import { config } from './selectSettlementData.js';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common,config],
  props: ['reconciliationType','supplierId'],
  data() {
    return {
      title:'请输入保单号选择对账数据',
      title1:'输入示例',
      visible: false,
      value:'',
      visible1:false,
      unmatchedList:[],
      showTable:false,
      ids: [],
      checkId: '',
      isAll: false, //全部产品
      total: null,
      tableData: [],
      selectArr: [], //表格选择的数据
    };
  },
  methods:{
    getReconciliationStatus(item){
      if(item == '0'){
        return '未对账'
      }else if(item == '1'){
        return '对账正常'
      }else if(item == '2'){
        return '对账异常'
      }else if(item == '3'){
        return '已对账'
      }
    },
    matchPolicy(){
      if(!this.searchParams.value){
        this.$notice.msg("请输入保单号再匹配")
        return
      }
      let code = null 
      //去除换行
      code = this.searchParams.value.split(/[(\r\n)\r\n]+/)
      code.forEach((item, index) => { // 删除空项
        if (item == '\t' || item == '') {
              code.splice(index, 1);
            }
      })
      this.searchParams.noList = code 
      this.getColumns()
      this.getList();
      this.getUnmatchedResult()
      this.showTable = true
    },
    // 加入对账单
    addStatement() {
      if (this.ids && this.ids.length > 0 || this.isAll) {
        this.$http({
          url: `/buz/molCommissionConsult/batchAdd`,
          type: "POST",
          data: {
            checkId: this.checkId,
            ids: this.ids,
            isAll: this.isAll,
            commissionLogQuery: this.searchParams
          }
        }).then((res) => {
          this.ids = [];
          this.visible = false
          this.$emit('getList')
        })
      } else {
        this.$notice.msg("请至少选择一条记录")
      }
    },
    open(searchParams){
      this.visible = true
      this.checkId = searchParams.id
      this.isAll = false;
      this.searchParams={
        value:'',
      }
      this.showTable = false
      this.value = "00123456789008087\n00123456789008088\n00123456789008089\n..."
      this.searchParams.reconciliationType = searchParams.reconciliationType
      this.unmatchedList = []
      this.selectArr = []; 
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取未匹配数据
    getUnmatchedResult() {
      this.listLoading = true;
      this.searchParams.supplierId = this.supplierId
      this.$http({
        url: '/buz/commissionReconciliation/policy/noMatchResult',
        type: 'POST',
        data: {
          tab: '1',
          specialCondition:1,
          isFirst: 1,
          checkId:this.checkId,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchParams,
          reconciliationType:this.reconciliationType
        }
      })
        .then(res => {
          this.unmatchedList = res.data
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 获取列表
    getList() {
      this.searchParams.supplierId = this.supplierId
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionReconciliation/policy/result',
        type: 'POST',
        data: {
          tab: '1',
          specialCondition:1,
          isFirst: 1,
          checkId:this.checkId,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchParams,
          reconciliationType:this.reconciliationType
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    changeValue(value){
      this.searchParams[value] = this.searchParams[value].replace(/^0(0+)|[^\d]+/g, '') 
      this.searchParams[value] = this.searchParams[value] && Number(this.searchParams[value])
      return this.searchParams[value]
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.ids = [];
    },
    selectionChange(rows) {
      const pageIds = rows.map(item => item.id); //当前页勾选的
      const selectIds = this.ids.map(item => item); //已经添加的数据
      this.tableData.forEach(item => {
        if (pageIds.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.ids.push(item.id);
          selectIds.push(item.id);
        } else if (!pageIds.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.ids.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>

/deep/ .ivu-modal-body{
  max-height: 90vh !important;
}
/deep/ .ivu-input {
    &::placeholder{
      color: #999;
    }
  }
.matchingResult{
  margin-bottom: 20px;
  
  .textResult{
    font-size: 15px;
    margin-left: 5px;
  }
}

.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.vertical-center-modal .ivu-modal{
    top: 0;
}
.iconzhuyi1{
  color: #ffb300;
  margin-right: 2px;
}
/deep/ .ivu-alert-desc{
  margin-left: 25px;
}

.batchMatching{
  margin-top: 20px;
  .searchValueBtn{
    display: flex;
    align-items: center;
    /deep/ .ivu-btn{
      min-width: 100px;
      margin-left: 10px;
    }
  }
  .batchBtn{
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    .toggleBtn {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
  
}
.tipsTitle{
  margin: 20px 0;
}
.ivu-alert{
  height: 160px;
  overflow-y:scroll;
}
.label {
  position: relative;
  .tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    bottom: -40px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -0px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 29px;
      transform: rotateZ(135deg);
    }
  }
}
.tools-box{
  justify-content: flex-start;
  margin-top: 10px;
}
.ivu-modal-footer{
  text-align: right;
}
.my-modal{
  .ivu-modal-footer {
    padding-bottom:40px;
    z-index: 1000;
    .ivu-btn {
      min-width: 100px;
      margin-right: 10px;
      &:last-child{
        margin-right: 12px;
      }
    }
  }
}


/deep/ .ivu-table-tip table {
    min-height: 180px;
  }
</style>